{
  "title": "Add Household Member",
  "client": "Client",
  "relationship": "Relationship",
  "relationshipTo": "Relationship to {{whom}} (primary member)",
  "alreadyMemberOf": "Client is already member of",
  "thisHousehold": "this household",
  "anotherHousehold": "another household",
  "memberSummary": "Member Summary",
  "pleaseReview": "Please review your information to ensure it’s correct.",
  "name": "Name",
  "dateOfBirth": "Date of Birth",
  "continue": "Continue",
  "added": "{{memberName}} has been added to this household",
  "failed": "Adding a new member failed.",
  "done": "Done",
  "createNewClient": "Create new client",
  "accessType": "Permissions",
  "establishedDate": "Established Date"
}
